<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <div class="module-container">
            <h1 class="module-name font-variable font-bold color-1">{{ $t("DGPrediction") }}</h1>
            <div class="module-descript container font-variable font-bold color-1">{{ $t("DGPredictionDesc2") }}</div>
            <div class="module-body container">
                <!-- * 选择器 - 用于引入ui-select样式 -->
                <ui-select class="module-hidden" v-model="mode" :candidates="vars.views" hidden />
                <!-- * 导航 -->
                <div class="module-navigations">
                    <template v-for="value in vars.views" :key="value.value">
                        <h2
                            class="module-navigation font-variable font-bold color-1"
                            :class="{ active: mode == value.value }"
                            @click="mode = value.value">
                            {{ value.label }}
                        </h2>
                    </template>
                </div>

                <div class="module-content">
                    <component :is="view" />
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiSelect } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组合函数
const { vars, refs, computeds } = useComposable();
const { view } = computeds;
const { mode } = refs;
</script>

<style lang="less" scoped>
.module-container {
    --size-64-32-32: 64px;
    --size-128-48-40: 128px;
    .module-name {
        --uisize-font-size: 44px;
    }

    .module-descript,
    .module-navigation {
        --uisize-font-size: 18px;
    }
}
@media (max-width: 1920px) {
    .module-container {
        --size-64-32-32: 32px;
        --size-128-48-40: 48px;
        .module-name {
            --uisize-font-size: 40px;
        }
    }
}
@media (max-width: 1600px) {
    .module-container {
        --size-128-48-40: 40px;
        .module-name {
            --uisize-font-size: 30px;
        }
    }
}
.module-container {
    margin-top: var(--size-128-48-40);
    .module-name,
    .module-descript {
        text-align: center;
    }
    .module-descript {
        margin-top: 8px;
    }
    .module-body {
        margin-top: var(--size-64-32-32);
        border-radius: 8px;
        background-color: var(--ui-color-7);
        .module-hidden {
            display: none;
        }

        .module-content {
            overflow: hidden;
        }

        .module-navigations {
            height: 64px;
            padding: 0 var(--size-64-64-40);
            border-bottom: 1px solid var(--uicolor-font-4);
            .module-navigation {
                cursor: pointer;
                display: inline-block;
                position: relative;
                transition: all 0.3s;
                line-height: 64px;
                &::before {
                    left: 50%;
                    width: 0;
                    height: 5px;
                    bottom: -2px;
                    content: "";
                    position: absolute;
                    transition: all 0.3s;
                    background-color: var(--uicolor-main-color);
                }

                &:hover,
                &.active {
                    color: var(--uicolor-main-color);
                }

                &.active::before {
                    left: 0;
                    width: 100%;
                }
            }

            .module-navigation:not(:first-child) {
                margin-left: 40px;
            }
        }
    }
}
</style>
